import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, ModalController, ViewController } from 'ionic-angular';

import { SelectPage } from '../';
import { ScheduleMarketing as Schedule, MasterMarketing as Master } from '@providers/index';

import { DatePicker } from '@ionic-native/date-picker';

import { Utility } from '@providers/resources/utility';

@Component({
  selector: 'page-notes',
  templateUrl: 'page.html'
})
export class FormSchedulePage {

  form = {
    id         : '',
    activity   : '',
    date_start : '',
    date_end   : '',
    description: '',
    pic_name   : '',
    pic_id     : '',
    tender_id  : '',
    state_id   : 1,
    stage_id   : '',
  };
  listStage: any = [];
  tender   : any = {};
  loading  : any;

  buildApk = this.utility.buildApk;
  
  constructor(
    public  navCtrl    : NavController,
    public  navParams  : NavParams,
    private alertCtrl  : AlertController,
    private toastCtrl  : ToastController,
    public  loadingCtrl: LoadingController,
    public  modalCtrl  : ModalController,
    public  viewCtrl   : ViewController,
    public  scheduleApi: Schedule,
    public  masterApi  : Master,
    public  datePicker : DatePicker,
    public  utility    : Utility
  ) {

    this.tender = this.navParams.get('tender');
    if(this.navParams.get('rec')!=undefined){
      this.form = this.navParams.get('rec');
    }
    this.getStage();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  stageChange(p,c){
    this.form.activity = c.text;
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }
  
  getStage(){
    this.showLoading();
    let params = {};
    this.masterApi.stage(params).subscribe((resp:any) => {
      this.listStage = resp.data;
    });
    this.loading.dismiss();
  }

  pilihPIC() {
    let picModal = this.modalCtrl.create(SelectPage, { select_mod: 2 });
    picModal.onDidDismiss(data => {
      if(data.item){
        this.form.pic_name = data.item.name;
        this.form.pic_id   = data.item.user_id;
      } 
    console.log(data.item);
    });
    picModal.present();
  }

  save(){    
    this.showLoading()
    this.form.tender_id = this.tender.id;
    let params = this.form;
    this.scheduleApi.post(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      this.navCtrl.pop();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });   
  }

  selectDateStart(){
    this.datePicker.show({
      date: new Date(),
      mode: 'date',
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT
    }).then(
      date => this.form.date_start = new Date(date.getTime() - 
      date.getTimezoneOffset()*60000).toISOString(),
      err  => console.log('ERROR : '+ err)
    );
  }
  selectDateEnd(){
    this.datePicker.show({
      date: new Date(),
      mode: 'date',
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT
    }).then(
      date => this.form.date_end = new Date(date.getTime() - 
      date.getTimezoneOffset()*60000).toISOString(),
      err  => console.log('ERROR : '+ err)
    );
  }


}



// WEBPACK FOOTER //
// ./src/pages/marketing/form_schedule/page.ts